<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <!-- <img
          src="static/img/banners/mi espacio banner.svg"
          class="img-responsive"
          alt="banner de mi espacio en avanti"
        /> -->
      </div>
    </div>
    <div class="row">
        <div class="col-md-4">
            <label for="">Terapeuta:</label>
            <select name="terapeuta" id="" v-model="selectTerapeuta" class="form-control">
                <option  v-for="item in optionTerapeuta" :key="item.id" :value="item">{{ item.nombres + ' ' + item.apellidos }}</option>
            </select>
        </div>
        <div class="col-md-4">
            <button @click="buscarInformacion()" class="btn btn-success btn-fill" style="margin-top:8%;">Buscar información</button>
        </div>
    </div>
    <div class="row"> <br>
      <div class="col-md-12">
        <center>
          <img :src="foto" alt="imagen del terapeuta" class="img-responsive img-ter img-thumbnail" style="border-radius: 10px;">
        </center>
      </div>
      <div class="col-md-12">
        <center>
          <h4 class="nombre-ter">{{nombre}} <i class="fa fa-circle" style="font-size:7px;"></i> <span style="color:#E3097E;">{{usuario}}</span> </h4>
        </center>
      </div>
    </div>
    <!-- <div class="row">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-12">
            <h4>Sesiones programadas hoy</h4>
          </div>
          <div
            class="col-xs-12 col-sm-6 col-md-3"
            v-for="card in card_dia"
            :key="card.title"
          >
            <stats-card style="box-shadow: 0px 0px 0px #999">
              <div class="icon-big text-center" slot="header">
                <img :src="card.img" v-if="card.img != ''" :alt="card.title" />
                <i style="color: #e3097e" v-else :class="card.icon"></i>
              </div>
              <div class="numbers" slot="content">
                <strong
                  ><p style="color: grey">{{ card.title }}</p></strong
                >
                <strong style="font-size: 30px">{{ card.value }}</strong>
              </div>
            </stats-card>
          </div>
        </div>
      </div>
    </div> -->
    <div class="row" v-if="selectTerapeuta != ''">
      <div class="col-md-12">
        <h4>Sesiones realizadas hoy</h4>
      </div>
      <div
        class="col-xs-12 col-sm-6 col-md-3"
        v-for="card in card_dia2"
        :key="card.title"
      >
        <stats-card style="box-shadow: 0px 0px 0px #999">
          <div class="icon-big text-center" slot="header">
            <img :src="card.img" v-if="card.img != ''" :alt="card.title" />
            <i style="color: #e3097e" v-else :class="card.icon"></i>
          </div>
          <div class="numbers" slot="content">
            <strong
              ><p style="color: grey">{{ card.title }}</p></strong
            >
            <strong style="font-size: 30px">{{ card.value }}</strong>
          </div>
        </stats-card>
      </div>
    </div>
    <div class="row" v-if="selectTerapeuta != ''">
      <div class="col-md-12">
        <h4>Objetivos y logros</h4>
      </div>
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <div class="row">
              <div class="col-xs-2 col-md-1">
                <img
                  class="img-responsive img-header"
                  src="static/img/ICONOS/logro pendiente.svg"
                  alt="icono de avanti"
                />
              </div>
              <div class="col-xs-10 col-md-7 caja-titulo">
                <strong class="card-title"
                  >Objetivos y logros próximos a cumplirse ( {{objetivosProximos.length}} )</strong>
              </div>
              <div class="col-md-2">
                <download-excel
                  class="btn btn-success btn-fill btn-sm pull-left"
                  style="border-radius: 0px"
                  :data="objetivosProximos"
                  :fields="json_fieldsProximos"
                  worksheet="My Worksheet"
                  v-if="objetivosProximos != ''"
                  :name="'objetivosProximos' + fechaActual"
                >
                  Exportar a excel
                </download-excel>
              </div>
              <div class="col-md-2">
                  <button @click="push('diarioCampo/objetivos-y-logros')" class="btn btn-warning btn-fill btn-sm" style="border-radius: 0px">Gestionar Objetivos</button>
              </div>
            </div>
          </div>
          <div class="card-content">
            <div class="row">
              <div class="col-md-12">
                <el-table
                  class="table-striped table-condensed table-responsive"
                  :data="objetivosProximosPag"
                  size="mini"
                >
                  <el-table-column label="Paciente" width="250">
                    <template slot-scope="props">
                      <small class="grey-text">{{
                        props.row.PacApe1 + " " + props.row.PacNom1
                      }}</small>
                    </template>
                  </el-table-column>
                  <el-table-column label="Fec. Ingreso" width="150">
                    <template slot-scope="props">
                      <span class="grey-text">{{ props.row.ObjFec }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="Fec. Finalización" width="150">
                    <template slot-scope="props">
                      <span class="grey-text">{{ props.row.ObjFecCum }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="Objetivo" width="440">
                    <template slot-scope="props">
                      <span class="grey-text">{{ props.row.ObjObj }}</span>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <p-pagination
              class="pull-right"
              v-model="paginationProximo.currentPage"
              :per-page="paginationProximo.perPage"
              :total="paginationProximo.total"
            ></p-pagination>
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <br />
        <br />
        <div class="card">
          <div class="card-header">
            <div class="row">
              <div class="col-xs-2 col-md-1">
                <img
                  class="img-responsive img-header"
                  src="static/img/ICONOS/logro.svg"
                  alt="icono de avanti"
                />
              </div>
              <div class="col-xs-8 col-md-7 caja-titulo">
                <strong class="card-title"
                  >Objetivos con estado "Pendiente por confirmar" ( {{objetivosPendientes.length}} )</strong
                >
              </div>
              <div class="col-md-2">
                <download-excel
                  class="btn btn-success btn-fill btn-sm pull-left"
                  style="border-radius: 0px"
                  :data="objetivosPendientes"
                  :fields="json_fieldsProximos"
                  worksheet="My Worksheet"
                  v-if="objetivosPendientes != ''"
                  :name="'objetivosPendienteConfirmar' + fechaActual"
                >
                  Exportar a excel
                </download-excel>
              </div>
              <div class="col-md-2">
                  <button @click="push('diarioCampo/objetivos-y-logros')" class="btn btn-warning btn-fill btn-sm" style="border-radius: 0px">Gestionar Objetivos</button>
              </div>
            </div>
          </div>
          <div class="card-content">
            <div class="row">
              <div class="col-md-12">
                <el-table
                  class="table-striped table-condensed table-responsive"
                  :data="objetivosPendientesPag"
                  size="mini"
                >
                  <el-table-column label="Paciente" width="250">
                    <template slot-scope="props">
                      <small class="grey-text">{{
                        props.row.PacApe1 + " " + props.row.PacNom1
                      }}</small>
                    </template>
                  </el-table-column>
                  <el-table-column label="Fec. Ingreso" width="150">
                    <template slot-scope="props">
                      <span class="grey-text">{{ props.row.ObjFec }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="Fec. Finalización" width="150">
                    <template slot-scope="props">
                      <span class="grey-text">{{ props.row.ObjFecCum }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="Objetivo" width="440">
                    <template slot-scope="props">
                      <span class="grey-text">{{ props.row.ObjObj }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column  fixed="left" width="50">
                    <template slot-scope="props">
                        <i class="fa fa-check" style="color:orange;" v-if="props.row.ObjLog!=null"></i>
                        <i class="fa fa-close" style="color:red;" v-else></i>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <p-pagination
              class="pull-right"
              v-model="paginationPendiente.currentPage"
              :per-page="paginationPendiente.perPage"
              :total="paginationPendiente.total"
            ></p-pagination>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="selectTerapeuta != ''">
      <div class="col-md-12">
        <h4>Pacientes liderados</h4>
      </div>
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <div class="row">
              <div class="col-xs-2 col-md-1">
                <img
                  class="img-responsive img-header"
                  src="static/img/ICONOS/lider paciente.svg"
                  alt="icono de avanti"
                />
              </div>
              <div class="col-xs-10 col-md-8 caja-titulo">
                <strong class="card-title">Pacientes liderados </strong>
              </div>
              <div class="col-xs-12 col-md-3" style="padding-top: 2%">
                <input
                  type="text"
                  class="form-control"
                  v-model="searchPaciente"
                  placeholder="Buscar paciente..."
                />
                <br />

                <download-excel
                  class="btn btn-success btn-fill btn-sm pull-left"
                  style="border-radius: 0px"
                  :data="pacientesCargo"
                  :fields="json_fieldsPacientes"
                  worksheet="My Worksheet"
                  v-if="pacientesCargo != ''"
                  :name="'pacientesACargo' + fechaActual"
                >
                  Exportar a excel
                </download-excel>
              </div>
            </div>
            <hr />
          </div>
          <div class="card-content">
            <el-table
              class="el-table table-striped table-condensed table-responsive"
              :data="pacientesCargoPag"
              size="mini"
            >
              <el-table-column label="Nombres y Apellidos" width="350">
                <template slot-scope="props">
                  <span style="font-size: 13px; color: grey">{{
                    props.row.PacApe1 + " " + props.row.PacNom1
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="Edad" width="200">
                <template slot-scope="props">
                  <span class="grey-text">{{ calcularEdad(props.row.PacFecNac) }}</span>
                </template>
              </el-table-column>
              <el-table-column label="Numero de documento" width="200">
                <template slot-scope="props">
                  <span class="grey-text">{{ props.row.PacNumDoc }}</span>
                </template>
              </el-table-column>
              <el-table-column width="250" label="DX">
                <template slot-scope="props">
                  <span class="grey-text">{{ props.row.dx }}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="card-footer">
            <p-pagination
              class="pull-right"
              v-model="paginationPacienteCargo.currentPage"
              :per-page="paginationPacienteCargo.perPage"
              :total="paginationPacienteCargo.total"
            ></p-pagination>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="selectTerapeuta != ''">
      <div class="col-md-12">
        <h4>Sesiones realizadas</h4>
      </div>
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <div class="row">
              <div class="col-xs-2 col-md-1">
                <img
                  class="img-responsive img-header"
                  src="static/img/ICONOS/AARR.svg"
                  alt="icono de avanti"
                />
              </div>
              <div class="col-xs-10 col-md-10 caja-titulo">
                <strong class="card-title">Sesiones Realizadas <span v-if="hisAtenciones.length>0">( {{hisAtenciones.length}} )</span> </strong>
              </div>
              <div class="col-md-3">
                <br />
                <small>Fecha inicio:</small>
                <input
                  type="date"
                  v-model="fechaInicioHis"
                  class="form-control"
                />
              </div>
              <div class="col-md-3">
                <br />
                <small>Fecha fin:</small>
                <input type="date" v-model="fechaFinHis" class="form-control" />
              </div>
              <div class="col-md-3">
                <br />
                <small style="color: white">jj</small> <br />
                <button
                  class="btn btn-success"
                  @click="hisSesiones()"
                  style="border-radius: 0px"
                  v-if="selectTerapeuta != ''"
                >
                  Buscar atenciones
                  <i class="fa fa-search"></i>
                </button>
              </div>
              <div class="col-md-3">
                <small style="color: white">jj</small> <br />
                <br />
                <download-excel
                  class="btn btn-success btn-fill"
                  style="border-radius: 0px"
                  :data="hisAtenciones"
                  :fields="json_fieldsAtenciones"
                  worksheet="My Worksheet"
                  v-if="hisAtenciones != ''"
                  :name="'sesionesRealizadas' + fechaActual"
                >
                  Exportar a excel
                </download-excel>
              </div>
            </div>
            <hr />
          </div>
          <div class="card-content">
            <el-table
              class="el-table table-striped table-condensed"
              :data="sesionesRRPag"
              
            >
              <el-table-column label="Nombres y Apellidos" width="400">
                <template slot-scope="props">
                  <span style="font-size: 13px; color: grey">{{
                    props.row.PacApe1 + " " + props.row.PacNom1
                  }}</span>
                </template>
              </el-table-column>
               <el-table-column label="Entidad del paciente" width="250">
                <template slot-scope="props">
                  <span style="font-size: 13px; color: grey">{{
                    props.row.entidad
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="Fecha de atención" width="200">
                <template slot-scope="props">
                  <span class="grey-text">{{ props.row.ProFec | date }}</span>
                </template>
              </el-table-column>
              <el-table-column label="Hora" width="200">
                <template slot-scope="props">
                  <span class="grey-text">{{ props.row.hora }}</span>
                </template>
              </el-table-column>
              <el-table-column label="Lugar">
                <template slot-scope="props">
                  <span class="grey-text">{{ props.row.ProLug }}</span>
                </template>
              </el-table-column>
              <el-table-column label="Tipo">
                <template slot-scope="props">
                  <span class="grey-text">{{ props.row.ProTip }}</span>
                </template>
              </el-table-column>
              <el-table-column label="Valor">
                <template slot-scope="props">
                  <span class="grey-text">{{ formatearPesosColombianos(props.row.ProValTer) }}</span>
                </template>
              </el-table-column>
              <!-- <el-table-column width="100" label="Estado">
                <template slot-scope="props">
                  <span class="grey-text">{{ props.row.estado }}</span>
                </template>
              </el-table-column> -->
            </el-table>
          </div>
          <div class="card-footer">
            <p-pagination
              class="pull-right"
              v-model="paginationSesionesRR.currentPage"
              :per-page="paginationSesionesRR.perPage"
              :total="paginationSesionesRR.total"
            ></p-pagination>
          </div>
        </div>
      </div>
    </div>
    
  </div>
</template>
<script>
import Vue from "vue";
import StatsCard from "src/components/UIComponents/Cards/StatsCard.vue";
import formatearPesosColombianos from "../../global-services/formatear-pesos";
import axios from "axios";

import { Table, TableColumn, Select, Option } from "element-ui";
import PPagination from "src/components/UIComponents/Pagination.vue";
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Select);
Vue.use(Option);
export default {
  components: {
    StatsCard,
    PPagination,
  },
  computed: {
    pagedDataPendiente() {
      return this.objetivosPendientes.slice(
        this.fromPendiente,
        this.toPendiente
      );
    },
    objetivosPendientesPag() {
      if (!this.searchQuery) {
        this.paginationPendiente.total = this.objetivosPendientes.length;
        return this.pagedDataPendiente;
      }
      let result = this.objetivosPendientes.filter((row) => {
        let isIncluded = false;
        for (let key of this.propsToSearch) {
          let rowValue = row[key].toString().toLowerCase();
          if (
            rowValue.includes &&
            rowValue.includes(this.searchQuery.toLowerCase())
          ) {
            isIncluded = true;
          }
        }
        return isIncluded;
      });
      this.paginationPendiente.total = result.length;
      return result.slice(this.fromPendiente, this.toPendiente);
    },
    toPendiente() {
      let highBound = this.fromPendiente + this.paginationPendiente.perPage;
      if (this.totalPendiente < highBound) {
        highBound = this.totalPendiente;
      }
      return highBound;
    },
    fromPendiente() {
      return (
        this.paginationPendiente.perPage *
        (this.paginationPendiente.currentPage - 1)
      );
    },
    totalPendiente() {
      this.paginationPendiente.total = this.objetivosPendientes.length;
      return this.objetivosPendientes.length;
    },

    // pacientes a cargo <paginación>
    pagedDataPacientesCargo() {
      return this.pacientesCargo.slice(
        this.fromPacienteCargo,
        this.toPacienteCargo
      );
    },
    pacientesCargoPag() {
      if (!this.searchPaciente) {
        this.paginationPacienteCargo.total = this.pacientesCargo.length;
        return this.pagedDataPacientesCargo;
      }
      let result = this.pacientesCargo.filter((row) => {
        let isIncluded = false;
        for (let key of this.propsToSearch) {
          let rowValue = row[key].toString().toLowerCase();
          if (
            rowValue.includes &&
            rowValue.includes(this.searchPaciente.toLowerCase())
          ) {
            isIncluded = true;
          }
        }
        return isIncluded;
      });
      this.paginationPacienteCargo.total = result.length;
      return result.slice(this.fromPacienteCargo, this.toPacienteCargo);
    },
    toPacienteCargo() {
      let highBound =
        this.fromPacienteCargo + this.paginationPacienteCargo.perPage;
      if (this.totalPacienteCargo < highBound) {
        highBound = this.totalPacienteCargo;
      }
      return highBound;
    },
    fromPacienteCargo() {
      return (
        this.paginationPacienteCargo.perPage *
        (this.paginationPacienteCargo.currentPage - 1)
      );
    },
    totalPacienteCargo() {
      this.paginationPacienteCargo.total = this.pacientesCargo.length;
      return this.pacientesCargo.length;
    },
    // objetivos proximos <paginación>
    pagedDataObjetivosProximos() {
      return this.objetivosProximos.slice(
        this.fromObjetivosProximos,
        this.toObjetivosProximos
      );
    },
    objetivosProximosPag() {
      if (!this.searchQuery) {
        this.paginationProximo.total = this.objetivosProximos.length;
        return this.pagedDataObjetivosProximos;
      }
      let result = this.objetivosProximos.filter((row) => {
        let isIncluded = false;
        for (let key of this.propsToSearch) {
          let rowValue = row[key].toString().toLowerCase();
          if (
            rowValue.includes &&
            rowValue.includes(this.searchQuery.toLowerCase())
          ) {
            isIncluded = true;
          }
        }
        return isIncluded;
      });
      this.paginationProximo.total = result.length;
      return result.slice(this.fromObjetivosProximos, this.toObjetivosProximos);
    },
    toObjetivosProximos() {
      let highBound =
        this.fromObjetivosProximos + this.paginationProximo.perPage;
      if (this.totalObjetivosProximo < highBound) {
        highBound = this.totalObjetivosProximo;
      }
      return highBound;
    },
    fromObjetivosProximos() {
      return (
        this.paginationProximo.perPage *
        (this.paginationProximo.currentPage - 1)
      );
    },
    totalObjetivosProximo() {
      this.paginationProximo.total = this.objetivosProximos.length;
      return this.objetivosProximos.length;
    },

    // sesiones realizadas <paginación>
    pagedDataSesionesRR() {
      return this.hisAtenciones.slice(this.fromSesionesRR, this.toSesionesRR);
    },
    sesionesRRPag() {
      if (!this.searchQuery) {
        this.paginationProximo.total = this.hisAtenciones.length;
        return this.pagedDataSesionesRR;
      }
      let result = this.hisAtenciones.filter((row) => {
        let isIncluded = false;
        for (let key of this.propsToSearch) {
          let rowValue = row[key].toString().toLowerCase();
          if (
            rowValue.includes &&
            rowValue.includes(this.searchQuery.toLowerCase())
          ) {
            isIncluded = true;
          }
        }
        return isIncluded;
      });
      this.paginationSesionesRR.total = result.length;
      return result.slice(this.fromSesionesRR, this.toSesionesRR);
    },
    toSesionesRR() {
      let highBound = this.fromSesionesRR + this.paginationSesionesRR.perPage;
      if (this.totalSesionesRR < highBound) {
        highBound = this.totalSesionesRR;
      }
      return highBound;
    },
    fromSesionesRR() {
      return (
        this.paginationSesionesRR.perPage *
        (this.paginationSesionesRR.currentPage - 1)
      );
    },
    totalSesionesRR() {
      this.paginationSesionesRR.total = this.hisAtenciones.length;
      return this.hisAtenciones.length;
    },
  },
  data: () => ({
    selectTerapeuta: '',
    optionTerapeuta: [],
    searchQuery: "",
    fechaActual: "",
    fechaFin: "",
    paginationPendiente: {
      perPage: 5,
      currentPage: 1,
      perPageOptions: [5, 10, 25, 50, 100, 200, 300],
      total: 0,
    },
    paginationProximo: {
      perPage: 5,
      currentPage: 1,
      perPageOptions: [5, 10, 25, 50, 100, 200, 300],
      total: 0,
    },
    searchPaciente: "",
    paginationPacienteCargo: {
      perPage: 5,
      currentPage: 1,
      perPageOptions: [5, 10, 25, 50, 100, 200, 300],
      total: 0,
    },
    paginationSesionesRR: {
      perPage: 50,
      currentPage: 1,
      perPageOptions: [5, 10, 25, 50, 100, 200, 300],
      total: 0,
    },
    propsToSearch: [
      "PacNom1",
      "PacApe1",
      "PacNumDoc",
      "PacFecNac",
      "PacFecIng",
    ],
    ip: "https://avanti-erp.com/",
    pacientesCargo: [],
    objetivosProximos: [],
    objetivosPendientes: [],
    hisAtenciones: [],
    foto: ``,
    usuario: '',
    nombre: '',
    especialidad: '',
    fechaInicioHis: "",
    fechaFinHis: "",

    card_dia: [
      {
        title: "SSP Virtuales",
        value: 0,
        icon: "fa fa-play",
        img: "static/img/ICONOS/consulta virtual.svg",
      },
      {
        title: "SSP Presen.",
        value: 0,
        icon: "fa fa-users",
        img: "static/img/ICONOS/familia.svg",
      },
      {
        title: "SSP Totales",
        value: 0,
        icon: "fa fa-plus",
        img: "static/img/ICONOS/SSPP.svg",
      },
    ],
    card_dia2: [
      {
        title: "SSR virtuales",
        value: 0,
        icon: "fa fa-plus",
        img: "static/img/ICONOS/consulta virtual.svg",
      },
      {
        title: "SSR domicilio",
        value: 0,
        icon: "fa fa-plus",
        img: "static/img/ICONOS/AARR.svg",
      },
      {
        title: "SSR Cancel.",
        value: 0,
        icon: "fa fa-plus",
        img: "static/img/ICONOS/SSCC.svg",
      },
      {
        title: "SSR Totales",
        value: 0,
        icon: "fa fa-plus",
        img: "static/img/ICONOS/SSPP.svg",
      },

    ],
    // config JsonExcel

    json_fieldsProximos: {
      Nombres: "PacNom1",
      Apellidos: "PacApe1",
      "Fecha objetivo": "ObjFec",
      "Fecha fin objetivo": "ObjFecCum",
      Objetivo: "ObjObj",
    },
    json_fieldsPacientes: {
      Nombres: "PacNom1",
      Apellidos: "PacApe1",
      "Numero Documento": "PacNumDoc",
      "Edad": "Edad",
      "Dx": "dx",
      "Terapeuta" : "Terapeuta",
      "Especialiad": "Especialidad",
    },
    json_fieldsAtenciones: {
      Nombres: "PacNom1",
      Apellidos: "PacApe1",
      "Fecha de atención": "ProFec",
      hora: "hora",
      "Hora fin" : "horaFin",
      lugar: "ProLug",
      "Tipo de sesión": "ProTip",
      "Pago al terapeuta": "ProValTer",
    },
    json_data: [],
    json_meta: [
      [
        {
          key: "charset",
          value: "utf-8",
        },
      ],
    ],
  }),
  methods: {
    formatearPesosColombianos,
    selectTerapeutasFun: function(){
        const BASE_URL = `${this.ip}api/selectTerapeutasMiEspacio`;
        axios.get(BASE_URL).then(res => {
            this.optionTerapeuta = res.data.data;
        })
    },
    getEvents() {
      let fechaF = this.fechamasdias(this.fechaActual);
      axios
        .get(
          `https://www.googleapis.com/calendar/v3/calendars/${this.selectTerapeuta.email}/events?key=AIzaSyCS6MXgvS2kJs7YaIkUfFGx2O1fI9BKuC0&timeMin=${
            this.fechaActual
          }T00:00:00-05:00&timeMax=${fechaF}T00:00:00-05:00&maxResults=100`
        )
        .then((res) => {
          let datos = res.data.items;
          let domicilio = 0;
          let virtual = 0;
          datos.forEach((element) => {
            let tuDate1 = new Date();
            let tuDate2 = new Date(element.start.dateTime);

            let a = new Date(
              tuDate1.getFullYear(),
              tuDate1.getMonth(),
              tuDate1.getDate()
            );
            let b = new Date(
              tuDate2.getFullYear(),
              tuDate2.getMonth(),
              tuDate2.getDate()
            );

            if (element.location) {
              if (+a == +b) {
                virtual =
                  virtual +
                  this.calcularMinutos(
                    this.horaFormateada(element.start.dateTime),
                    this.horaFormateada(element.end.dateTime)
                  );
                // console.log()
              }
            } else {
              if (+a == +b) {
                domicilio =
                  domicilio +
                  this.calcularMinutos(
                    this.horaFormateada(element.start.dateTime),
                    this.horaFormateada(element.end.dateTime)
                  );
              }
            }
          });
          this.card_dia[1].value = domicilio;
          this.card_dia[0].value = virtual;
          this.card_dia[2].value = domicilio + virtual;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    horaFormateada(fecha) {
      var hora = new Date(fecha).getHours();
      var minutos = new Date(fecha).getMinutes();
      if (minutos == 0) {
        minutos = "00";
      }
      var horaFormateada = hora + ":" + minutos;
      return horaFormateada;
    },
    calcularMinutos(inicio, fin) {
      // Cogemos la hora inicial y final y obtenemos los minutos totales
      var horaInicial = this.devolverMinutos(inicio);
      var horaFinal = this.devolverMinutos(fin);

      if (horaInicial < horaFinal) {
        // Restamos los minutos finales con los minutos iniciales

        // console.log(
        //   "La cantidad de sesiones que se necesita es: " + (horaFinal - horaInicial / 60) + " sesion"
        // );
        let sesiones = (horaFinal - horaInicial) / 30;

        return Math.trunc(sesiones);
      } else {
        // document.getElementById("resultado").innerHTML =
        //   "La hora inicial tiene que ser inferior a la hora final";
      }
      // console.log(inicio)
    },
    devolverMinutos(horaMinutos) {
      return (
        parseInt(horaMinutos.split(":")[0]) * 60 +
        parseInt(horaMinutos.split(":")[1])
      );
    },
    fechamasdias: function (fecha) {
      var fecha = new Date(fecha);
      fecha.setDate(fecha.getDate() + 10);
      // console.log("fecha más 7 días", fecha);

      var fechaFormateada = "";
      var ahora_ano = fecha.getFullYear();
      var ahora_mes = fecha.getMonth() + 1;
      var ahora_dia = fecha.getDate();
      if (ahora_mes < 10 || ahora_dia < 10) {
        if (ahora_mes < 10) {
          ahora_mes = "0" + ahora_mes;
        }
        if (ahora_dia < 10) {
          ahora_dia = "0" + ahora_dia;
        }
        fechaFormateada = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
      } else {
        fechaFormateada = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
      }

      return fechaFormateada;
    },
    calcularFechaActual() {
      var fecha_hoy = new Date();

      var ahora_ano = fecha_hoy.getFullYear();
      var ahora_mes = fecha_hoy.getMonth() + 1;
      var ahora_dia = fecha_hoy.getDate();

      if (ahora_mes < 10 || ahora_dia < 10) {
        if (ahora_mes < 10) {
          ahora_mes = "0" + ahora_mes;
        }
        if (ahora_dia < 10) {
          ahora_dia = "0" + ahora_dia;
        }
        this.fechaActual = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
      } else {
        this.fechaActual = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
      }

      this.fechaFin = this.fechamasdias(this.fechaActual);
      this.objetivosProximosFun();
      // this.getEvents();
    },
    objetivosPendientesFun: function () {
      let datos = [];
      const BASE_URL = `${
        this.ip
      }api/objetivosPendienteConfirmar/${this.selectTerapeuta.usuario}/${
        this.fechaActual
      }`;
      axios
        .get(BASE_URL)
        .then((res) => {
          if (res.data.status == true) {
            
          }

          datos = res.data.data.concat(res.data.data2);

          datos.sort(function (a, b) {
            if (a.ObjFec > b.ObjFec) {
              return -1;
            }
            if (a.ObjFec < b.ObjFec) {
              return 1;
            }
            // a must be equal to b
            return 0;
          });
          this.objetivosPendientes = datos;
          console.log(this.objetivosPendientes, 'pendientes');
        })
        .catch((err) => {
          console.log(err);
        });
    },
    objetivosProximosFun: function () {
      let fecha = this.fechamasdias(this.fechaActual);
      const BASE_URL = `${this.ip}api/objetivosProximos/${this.selectTerapeuta.usuario}/${this.fechaActual}/${fecha}`;
      axios
        .get(BASE_URL)
        .then((res) => {
          if (res.data.status == true) {
            this.objetivosProximos = res.data.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    pacientesCargoFun: function () {
      const BASE_URL = `${this.ip}api/pacientesCargo/${this.selectTerapeuta.usuario}/${this.selectTerapeuta.id_rol}`;
      axios
        .get(BASE_URL)
        .then((res) => {
          if (res.data.status == true) {
            let datos = res.data.data;
            let datos_f = [];
            this.pacientesCargo = res.data.data;
            for (let index = 0; index < datos.length; index++) {
              datos_f.push({
                PacApe1 : datos[index].PacApe1,
                PacNom1 : datos[index].PacNom1,
                PacFecNac : datos[index].PacFecNac,
                PacNumDoc : datos[index].PacNumDoc,
                Edad : this.calcularEdad(datos[index].PacFecNac),
                dx: datos[index].dx,
                Terapeuta: this.nombre,
                Especialidad : this.especialidad
              })

              this.pacientesCargo = datos_f;
            }          
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    hisSesiones: function () {
      const BASE_URL = `${this.ip}api/hisSesiones/${this.selectTerapeuta.usuario}/${this.fechaInicioHis}/${this.fechaFinHis}`;
      axios
        .get(BASE_URL)
        .then((res) => {
          if (res.data.status == true) {
            this.hisAtenciones = res.data.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    hisSesionesHoy: function () {
      const BASE_URL = `${this.ip}api/hisSesionesHoy/${this.selectTerapeuta.usuario}/${this.selectTerapeuta.email}/${this.fechaActual}`;
      axios
        .get(BASE_URL)
        .then((res) => {
          if (res.data.status == true) {
            this.card_dia2[0].value = res.data.terapiasV;
            this.card_dia2[1].value = res.data.terapiasD;
            this.card_dia2[2].value = res.data.terapiasC;
            this.card_dia2[3].value = res.data.terapiasV + res.data.terapiasD + res.data.terapiasC;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    calcularEdad(fecha) {
      
        var fechaNacimiento = fecha
        var values = fechaNacimiento.split("-");
        var dia = values[2];
        var mes = values[1];
        var ano = values[0];

        var fecha_hoy = new Date();
        var ahora_ano = fecha_hoy.getFullYear();
        var ahora_mes = fecha_hoy.getMonth() + 1;
        var ahora_dia = fecha_hoy.getDate();

        var fechaActual = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
        // this.fechaIngreso = fechaActual;

        var edad = ahora_ano + 0 - ano;
        if (ahora_mes < mes) {
          edad--;
        }
        if (mes == ahora_mes && ahora_dia < dia) {
          edad--;
        }
        if (edad > 1900) {
          edad -= 1900;
        }

        // calculamos los meses
        var meses = 0;
        if (ahora_mes > mes) meses = ahora_mes - mes;
        if (ahora_mes < mes) meses = 12 - (mes - ahora_mes);
        if (ahora_mes == mes && dia > ahora_dia) meses = 11;

        // calculamos los dias
        var dias = 0;
        if (ahora_dia > dia) dias = ahora_dia - dia;
        if (ahora_dia < dia) {
          var ultimoDiaMes = new Date(ahora_ano, ahora_mes - 1, 0);
          var dias = ultimoDiaMes.getDate() - (dia - ahora_dia);
        }

        return edad + ' años y ' + meses + ' meses' ;
    },

    buscarInformacion: function(){
        if(this.selectTerapeuta.id_rol == 2){
          this.usuario = 'Fisioterapeuta';
          this.especialidad = 'Fisioterapia'
        }else if(this.selectTerapeuta.id_rol == 3){
          this.usuario = 'Fonoaudiólogo';
          this.especialidad = 'Fonoaudiología'
        }else if(this.selectTerapeuta.id_rol == 4){
          this.usuario = 'Terapeuta ocupacional';
          this.especialidad = 'Terapia ocupacional';
        }else if(this.selectTerapeuta.id_rol == 5){
          this.usuario = 'Terapeuta en educación especial';
          this.especialidad = 'Educación especial';
        }else{
          this.usuario = 'Psicólogo';
          this.especialidad = 'Psicología'
        }
        this.calcularFechaActual();
        this.objetivosPendientesFun();
        this.pacientesCargoFun();
        this.hisSesionesHoy();
        this.fechamasdias();
        this.foto = `https://avanti-erp.com/${this.selectTerapeuta.url_foto}`;
        this.nombre = `${this.selectTerapeuta.nombres} ${this.selectTerapeuta.apellidos}`;
        
        // console.log(this.selectTerapeuta);
    },
    push: function(route){
      this.$router.push(route);
    }
  },
  mounted() {
    this.selectTerapeutasFun();
    document.title = "Avanti | Administrar espacio";
  },
};
</script>
<style scoped>
.card-title {
  color: #6b6969;
  font-size: 13px;
  font-family: sans-serif;
  font-weight: bold;
  margin-top: 520px !important;
}

.card{
    box-shadow: 0 0 0 0;
}

.line-header {
  color: black;
  height: 5px;
}
.card-name {
  color: #302254;
  font-size: 20px;
  font-family: sans-serif;
}

.caja-titulo {
  padding-top: 2%;
  margin-left: -3%;
}

.img-header {
  width: 50px !important;
  height: 40px !important;
}

.img-ter {
  width: 200;
  height: 250px;

}

.btn {
  border-radius: 5px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/ADashboard/miEspacioAdmin.vue